'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('proxy-holder-property-select', {
      url: '/voting/:voteId/record-proxy-votes/:ballotId/proxy-holder-select/:proxy/property-select',
      template: '<proxy-holder-property-select></proxy-holder-property-select>',
        authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/ballot/proxy-holder-property-select/proxy-holder-property-select.routes.js